import React, { useRef, useState } from "react";

import { Field, Form, Formik } from "formik";
import Select from "react-select";

import {
  Button,
  Flex,
  Input,
  InputGroup,
  Grid,
  GridItem,
  SimpleGrid,
} from "@chakra-ui/react";

import PromotoriaService from "../../../main/services/PromotoriaService";
import VaraService from "../../../main/services/VaraService";
import DadosGeograficosService from "../../../main/services/DadosGeograficosService";

export default function FiltersRadioGroupTable(props) {
  const formRef = useRef(null);
  const { entidade, setData, searchBlock, setLoading } = props;

  const [municipios, setMunicipios] = useState({
    options: [],
    isLoading: false,
  });

  const handleGetMunicipios = () => {
    setMunicipios({ ...municipios, isLoading: true });

    DadosGeograficosService.getMunicipiosLogado(props.token).then((res) => {
      setMunicipios({ options: res.data, isLoading: false });
    });
  };
  const getPromotoriasLogado = () => {
    setLoading(true);

    if (entidade === "promotoria") {
      PromotoriaService.getPromotoriasLogado(props.token)
        .then((res) => {
          setLoading(false);
          setData(res.data);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      VaraService.pesquisarVaras("", "")
        .then((res) => {
          setLoading(false);
          setData(res.data);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      if (entidade === "promotoria") {
        const valuesToSend = {
          ...values,
          municipioId: values.municipioId ? values.municipioId.id : "",
        };
        setLoading(true);

        PromotoriaService.pesquisarPromotorias(valuesToSend)
          .then((res) => {
            setLoading(false);
            setData(res.data);
          })
          .catch(() => {
            setLoading(false);
          });
      } else if (entidade === "vara") {
        const valuesToSend = {
          ...values,
          comarca: values.comarca ? values.comarca.nome : "",
        };
        setLoading(true);

        VaraService.pesquisarVaras(valuesToSend)
          .then((res) => {
            setLoading(false);
            setData(res.data);
          })
          .catch(() => {
            setLoading(false);
          });
      }

      actions.setSubmitting(false);
    }, 200);
  };

  const handleResetAndSubmit = (resetForm, handleSubmit) => {
    if (props.situacao) {
      resetForm();
      getPromotoriasLogado();
    } else {
      resetForm();
    }
  };

  return (
    <Flex flexDir="column" alignItems="center" w="100%">
      <Formik
        initialValues={{
          nome: "",
          municipioId: "",
          comarca: "",
        }}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form
            ref={formRef}
            style={{ width: "100%" }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !searchBlock) {
                props.handleSubmit();
              }
            }}
          >
            <Flex flexDirection="column" alignItems="center">
              <Grid templateColumns="repeat(3, 1fr)" gap="25px" w="100%">
                <GridItem colSpan={{ base: 3, lg: 2 }} h="42px">
                  <Field name="nome">
                    {({ field, form }) => (
                      <InputGroup>
                        <Input
                          {...field}
                          name="nome"
                          autoFocus
                          id="search-nome"
                          backgroundColor="white"
                          autoComplete="off"
                          placeholder={`Pesquise pelo Nome da ${
                            entidade === "promotoria"
                              ? "Promotoria"
                              : "Vara da Infância"
                          }`}
                        />
                      </InputGroup>
                    )}
                  </Field>
                </GridItem>
                {entidade === "promotoria" && (
                  <GridItem colSpan={{ base: 3, lg: 1 }} h="42px">
                    <Select
                      isClearable={true}
                      value={props.values.municipioId || ""}
                      loadingMessage={() => "Carregando..."}
                      noOptionsMessage={() => "Sem opções"}
                      searchable={true}
                      onBlurResetsInput={false}
                      onCloseResetsInput={false}
                      getOptionLabel={(option) => option.nome}
                      getOptionValue={(option) => option.id}
                      autoload={false}
                      isLoading={municipios.isLoading}
                      options={municipios.options}
                      placeholder="Escolha o Município"
                      onChange={(value) => {
                        props.setFieldValue("municipioId", value);
                      }}
                      onFocus={
                        municipios.options.length === 0
                          ? handleGetMunicipios
                          : null
                      }
                    />
                  </GridItem>
                )}
                {entidade === "vara" && (
                  <GridItem colSpan={{ base: 3, lg: 1 }} h="42px">
                    <Select
                      isClearable={true}
                      value={props.values.comarca || ""}
                      loadingMessage={() => "Carregando..."}
                      noOptionsMessage={() => "Sem opções"}
                      searchable={true}
                      onBlurResetsInput={false}
                      onCloseResetsInput={false}
                      getOptionLabel={(option) => option.nome}
                      getOptionValue={(option) => option.id}
                      autoload={false}
                      isLoading={municipios.isLoading}
                      options={municipios.options}
                      placeholder="Escolha a Comarca"
                      onChange={(value) => {
                        props.setFieldValue("comarca", value);
                      }}
                      onFocus={
                        municipios.options.length === 0
                          ? handleGetMunicipios
                          : null
                      }
                    />
                  </GridItem>
                )}
              </Grid>

              <SimpleGrid
                mt="20px"
                columns={2}
                spacing="15px"
                w={{ base: "100%", lg: "40%" }}
              >
                <Button
                  id={`button-pesquisar-${entidade}`}
                  type="submit"
                  translate="no"
                  color="#FFF"
                  backgroundColor="#169499"
                  fontWeight={700}
                  fontSize="15px"
                  lineHeight="21.6px"
                  isDisabled={entidade === "promotoria" && searchBlock}
                  _hover={{ bg: "#169499" }}
                  isLoading={props.isSubmitting}
                  onClick={props.handleSubmit}
                >
                  Pesquisar
                </Button>
                <Button
                  id={`button-limpar-${entidade}`}
                  type="button"
                  color="#FFF"
                  backgroundColor="#169499"
                  fontWeight={700}
                  fontSize="15px"
                  lineHeight="21.6px"
                  onClick={() =>
                    handleResetAndSubmit(props.resetForm, props.handleSubmit)
                  }
                  _hover={{ bg: "#169499" }}
                >
                  {" "}
                  Limpar
                </Button>
              </SimpleGrid>
            </Flex>
          </Form>
        )}
      </Formik>
    </Flex>
  );
}
